/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchise_CreateInputs */

const cs_franchise_create = /** @type {(inputs: Franchise_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prodat licenci`)
};

const en_franchise_create = /** @type {(inputs: Franchise_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sell a license`)
};

/**
* | output |
* | --- |
* | "Sell a license" |
*
* @param {Franchise_CreateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_create = /** @type {((inputs?: Franchise_CreateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_CreateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_create(inputs)
	return cs_franchise_create(inputs)
});